import React from 'react'


export type BtnCloseModalProps = {
    classes?:string
    dataModalWin: string
}

const close = (dataModalWin:string) =>{

    // const modalWin = document.getElementById("creditos");

    const modalWin = document.querySelector(
        `[data-modal-win="${dataModalWin}"]`
      );

    const backdrop = document.querySelector(".js-backdrop");
    
    if(modalWin && backdrop){
        modalWin.classList.remove("visible-slideup");
        backdrop.classList.remove("visible-fadein");   
    }     
}


const BtnCloseModal = ({classes, dataModalWin}: BtnCloseModalProps) => {
    return (
        <button
            className={`${classes?classes:"btn btn-rounded btn-rounded-transparent btn-close"} `}
            aria-label="Cerrar ventana"
            onClick = { ()=>close(dataModalWin) }
        >
        <span className="btn__icon"><i className="icon icon-vpro-close"></i></span>
      </button>
    )
}

export default BtnCloseModal
